module.exports = __webpack_public_path__ + "media/icons/course-631b32b1.png";